<template>
  <div
    v-if="info && info.contactsInfo && info.contactsInfo.length"
    id="amiilink-container"
    class="amiilink-wrapper-dynamic"
    :style="`background-color: ${
      info.profileInfo && info.profileInfo.lksBgColor
        ? info.profileInfo.lksBgColor : 'transparent'}; border-color: ${
      info.profileInfo && info.profileInfo.lksBorderColor
        ? info.profileInfo.lksBorderColor : 'transparent'};`"
  >
    <component
      :is="'style'"
      v-if="info.profileInfo && info.profileInfo.customCss"
    >
      {{ info.profileInfo.customCss }}
    </component>
    <!-- <h3
      class="amiilink-title"
      :style="txtColor"
    >Contactos y enlaces</h3> -->

    <a
      v-for="link in info.contactsInfo"
      :key="link.url"
      :href="link.url"
      target="_blank"
      :class="['amiilink-item-dynamic',
               info.profileInfo && info.profileInfo.template]"
      :style="templateStyles"
    >
      <div class="amiilink-icon-wrapper">
        <img
          v-if="link.image"
          :src="link.image.url"
          class="amiilink-img-icon"
        >
        <img
          v-else-if="link.imgUrl"
          :src="link.imgUrl"
          class="amiilink-img-icon"
        >
        <i
          v-else
          :class="getIconClass(link.icon)"
        />
      </div>
      <span class="amiilink-text">{{ link.name }}</span>
    </a>
  </div>
</template>

<script>

export default {
  name: 'SeccionEnlaces',
  components: {
  },
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      // imgPath: imgPath+'dir/',
    };
  },
  computed: {
    templateStyles() {
      let templateStyles = '';
      const pi = this.info && this.info.profileInfo
        ? this.info.profileInfo : {};
      const template = pi.template;
      const color = pi.btnColor
        || pi.bgColor || '#ffffff';
      const fondo = pi.btnBgColor
        || pi.txtColor || '#002196';
      const border = pi.btnBorderColor || fondo;
      if (template === 'glass') {
        templateStyles = `
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: ${color } !important;
        `;
      } else if (template === 'outline') {
        templateStyles = `
          background: transparent;
          border: 2px solid ${border};
          color: ${fondo} !important;
        `;
      } else if (template === 'retro') {
        templateStyles = `
          background-color: #ffffff;
          border: 2px solid ${border};
          border-radius: 10px;
          color: ${fondo} !important;
          box-shadow: 3px 3px 0px ${border};
        `;
      } else {
        // Solid (Default)
        templateStyles = `
          background-color: ${fondo};
          color: ${color} !important;
          border: 2px solid ${border};
        `;
      }
      return templateStyles;
    },
  },
  methods: {
    getIconClass(iconName) {
      const mapping = {
        'instagram': 'fab fa-instagram',
        'whatsApp': 'fab fa-whatsapp',
        'facebook': 'fab fa-facebook',
        'tiktok': 'fab fa-tiktok',
        'twitter': 'fab fa-twitter',
        'youtube': 'fab fa-youtube',
        'telegram': 'fab fa-telegram',
        'linkedin': 'fab fa-linkedin',
        'email': 'fas fa-envelope',
        'phone': 'fas fa-phone',
        'link': 'fas fa-link',
      };
      if (!iconName) return mapping['link'];
      const lower = iconName.toLowerCase();
      if (lower.includes('whatsapp')) return 'fab fa-whatsapp';
      if (lower.includes('instagram')) return 'fab fa-instagram';
      if (lower.includes('facebook')) return 'fab fa-facebook';
      if (lower.includes('telegram')) return 'fab fa-telegram';
      if (lower.includes('linkedin')) return 'fab fa-linkedin';
      if (lower.includes('youtube')) return 'fab fa-youtube';
      if (lower.includes('tiktok')) return 'fab fa-tiktok';
      if (lower.includes('twitter')) return 'fab fa-twitter';
      if (lower.includes('email')) return 'fas fa-envelope';
      if (lower.includes('phone')) return 'fas fa-phone';
      if (lower.includes('link')) return 'fas fa-link';
      return mapping[iconName] || mapping['link'];
    },
  },
};
</script>

<style lang="scss" scoped>
.amiilink-wrapper-dynamic {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 40px;
  position: relative;
  border-radius: 25px;
  box-shadow: 0 15px 45px rgba(0,0,0,0.08);
  border-style: solid;
  border-width: 2px;
  transition: all 0.3s ease;
}
.amiilink-title {
  text-align: center;
  font-weight: 800;
  font-size: 1.8rem;
  margin-bottom: 25px;
  margin-top: 0;
  letter-spacing: -0.5px;
}
.amiilink-item-dynamic {
  display: flex;
  align-items: center;
  padding: 8px 18px;
  text-decoration: none !important;
  border-radius: 15px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background-clip: padding-box;
}
.amiilink-item-dynamic:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 25px rgba(0,0,0,0.12);
}
.amiilink-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 1.5rem;
  flex-shrink: 0;
}
.amiilink-img-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.amiilink-text {
  letter-spacing: 0.5px;
  flex-grow: 1;
  text-align: center;
  margin-right: 40px;
}
.amiilink-edit-wrapper {
  position: absolute;
  top: 25px;
  right: 25px;
  z-index: 10;
}
.amiilink-edit-btn {
  background: rgba(255,255,255,0.9);
  backdrop-filter: blur(4px);
  border: 1px solid #ddd;
  color: #333;
  padding: 6px 14px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  transition: all 0.2s;
  font-size: 0.85rem;
  font-weight: bold;
}
.amiilink-edit-btn i {
  margin-right: 6px;
}
.amiilink-edit-btn:hover {
  background: #ffffff;
  border-color: #bbb;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}
</style>
